<template>
  <v-row ref="widget" align="center" justify="center">
    <v-card width="540">
      <!-- <v-card-title class="py-4 text-center">
        <v-spacer />
        <v-sheet rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" width="100">
              <v-img :src="link.account.logo" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-spacer />
      </v-card-title>
      <v-divider /> -->
      <!-- <v-card-subtitle class="py-4">
        <v-row>
          <v-col class="text-center" cols="12">
            <span class="d-block body-1 text--secondary font-weight-medium">{{payment.description}}</span>
            <span class="d-block body-2 text--secondary font-weight-medium">{{payment.account.name}} <template v-if="payment.customer">para {{payment.customer.name}}</template></span>
            <span class="d-block text-h6 text--secondary font-weight-medium" v-if="payment.status !== 'succeeded'">{{payment.amount | currency(payment.currency)}} {{payment.currency}}  del {{payment.date | date}}</span>
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider /> -->
      <v-card-text class="px-0 background">
        <v-row class="px-4 py-6" no-gutters>
          <v-col class="text-center">
            <template v-if="instance.status === 'succeeded'">
              <v-icon color="primary" large>mdi-check</v-icon>
              <span class="d-block text-h6 primary--text font-weight-medium">Tu pago se ha realizado con éxito</span>
              <span class="d-block mt-6 text-h4 text--secondary font-weight-medium">{{ instance.amount | currency(link.currency) }} {{ link.currency }}</span>
              <span class="d-block my-2 text--primary">pagados a través de</span>
              <span class="d-block"><img :src="require(`@/assets/appAsset-brand--${instance.gateway}.svg`)" :alt="p" height="28"></span>

              <template v-if="link.return_url">
                <span class="d-block mt-8 text--secondary">serás redireccionado automáticamente en <strong>{{ counter }}</strong> segundos</span>
                <v-btn @click="finish" :color="link.account.color_background" dark :ripple="false" text>Salir ahora</v-btn>
              </template>

              <template v-if="link.end_description">
                <span class="d-block mt-8 text--secondary">{{link.end_description}}</span>
              </template>
            </template>

            <template v-if="instance.status === 'failed'">
              <v-icon color="red" large>mdi-alert</v-icon>
              <span class="d-block text-h6 red--text font-weight-medium">Tu pago ha fallado</span>
              <span class="d-block mt-6">{{ statusDetail }}</span>
              <v-btn class="mt-8" :to="{ name: 'PaymentLink', params: { pk: link.publishable_key } }" :color="link.account.color_background" dark height="40">Volver a intentarlo</v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import gateways from '../../collections/gateways'

import GenericViewMixin from '../../mixins/GenericViewMixin'
import WidgetViewMixin from '../../mixins/WidgetViewMixin'

export default {
  name: 'p-intent-retrieve',
  mixins: [
    GenericViewMixin,
    WidgetViewMixin
  ],
  data: () => ({
    counter: 7,
    gateway: {},
    gateways: gateways,
    statusDetail: ''
  }),
  computed: mapState({
    instance: state => state.paymentLinks.intentsDetail,
    link: state => state.paymentLinks.linksDetail
  }),
  created () {
    console.log('this.instance', this.instance)
    if (this.instance.status === 'pending') {
      this.$store.dispatch('paymentLinks/RETRIEVE', {
        resource: 'publishable/payment_links/intents',
        id: this.instance.publishable_key
      })
    }

    if (this.instance.status === 'failed') {
      this.gateway = this.gateways.find(gateway => gateway.id === this.instance.gateway)
      this.statusDetail = this.gateway.statusReasons[this.instance.status_reason] || null
    }

    if (this.instance.status === 'succeeded') {
      this.startCountdown()
    }
  },
  methods: {
    finish () {
      this.onRedirect(this.link.return_url)
    },
    startCountdown () {
      const interval = setInterval(() => {
        this.counter -= 1

        if (this.counter === 0) {
          clearInterval(interval)
          this.finish()
        }
      }, 1000)
    }
  }
}
</script>